import { alpha, Box, IconButton, Typography } from "@mui/material";
import { styled , Theme } from "@mui/material/styles";
import { RefObject } from "react";

export const RootContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%"
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "end",
  alignItems: "end",
  backgroundColor: theme.customColors?.backgroundPrimaryLighterAlternative,
  width: "70vw",
  height: "85vh",
  padding: "30px",
  borderRadius: "10px",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    padding: "20px",
    width: "100vw",
    height: "100vh"
  }
}));

export const ModalHeaderContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%"
}));

export const TitleContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "start"
}));

export const CloseButton = styled(IconButton)(() => ({
  top: 0,
  right: 0,
  zIndex: 1
}));

export const Divider = styled(Box)(({ theme }) => ({
  width: "100%",
  borderBottom: `1px solid ${theme.palette.divider}`,
  marginTop: "16px",
  marginBottom: "16px"
}));

type MessagesContainerProps = {
  theme: Theme;
  blockUserInput: boolean;
  ref: RefObject<HTMLDivElement>;
  gap: string;
};

export const MessagesContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "blockUserInput"
})(({ theme, blockUserInput }: MessagesContainerProps) => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  overflowY: "scroll",
  overflowX: "hidden",
  pointerEvents: blockUserInput ? "none" : "auto",
  position: "relative",
  paddingX: "10px",
  width: "100%",
  height: "100%",
  "&::-webkit-scrollbar": {
    width: "6px"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "transparent",
    borderRadius: "8px",
    opacity: 0,
    "&:hover": {
      background: alpha(theme.customColors.systemPrimary01,0.2)
    }
  }
}));

export const WelcomeMessageContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
  paddingLeft: "30px",
  paddingRight: "30px"
}));

export const WelcomeMessage = styled(Typography)(() => ({
  textAlign: "center",
  fontSize: "18px",
  userSelect: "none"
}));

export const LoadingHistoryContainer = styled(Typography)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 3
}));

export const LoadingHistoryMessage = styled(Typography)(() => ({
  fontSize: "14px",
  userSelect: "none"
}));

export const SessionTerminatedMessageContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "20px",
  paddingBottom: "20px",
  width: "100%"
}));

export const SessionTerminatedMessage = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  color: theme.customColors.textPrimary
}));
